<div *ngFor="let superCategory of mainSuperCategories">
    <button mat-menu-item (click)="changeSuperCategory($event)">
        <span>{{superCategory.nombre}}</span>
    </button>
</div>